/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateGuestReservationPayload } from 'api/actions/create-guest-reservation/create-guest-reservation-payload';
import { CreateGuestReservationPathParameters } from 'api/actions/create-guest-reservation/create-guest-reservation-path-parameters';
import { CreateGuestReservationResponse } from 'api/actions/create-guest-reservation/create-guest-reservation-response';

type CreateGuestReservationQueryParameters = Record<string, any>;

/**
 * The path of the CreateGuestReservation action.
 */
export const createGuestReservationActionPath = new SweetPath<keyof CreateGuestReservationPathParameters>(
  '/reservations/public',
  { path: '{param}' }
);

/**
 * Creates a contextualized CreateGuestReservation actions.
 */
export default function createCreateGuestReservationAction(axios: AxiosInstance) {
  return function createGuestReservationAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: CreateGuestReservationQueryParameters;
    payload: CreateGuestReservationPayload;
  }) {
    const path = createGuestReservationActionPath.original;

    return axios.post<CreateGuestReservationResponse, CreateGuestReservationResponse, CreateGuestReservationPayload>(
      path,
      payload
    );
  };
}
